import React from 'react';
import SequenceGame from './SequenceGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <SequenceGame />
    </div>
  );
}

export default App;